import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-more\"><path d=\"M176 510.976a56 56 0 1 0 112 0 56 56 0 0 0-112 0z m280 0a56 56 0 1 0 112 0 56 56 0 0 0-112 0z m280 0a56 56 0 1 0 112 0 56 56 0 0 0-112 0z\" p-id=\"3356\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol